import React from "react";

const TicketsSkeleton = () => {
  return (
    <>
      {[1, 2, 3].map((item) => (
        <div key={item} className="flex items-center gap-3 px-4 py-3 border-b border-dark-200 dark:border-dark-700">
          {/* Avatar skeleton */}
          <div className="w-10 h-10 rounded-full bg-dark-200 dark:bg-dark-700 animate-pulse flex-shrink-0" />

          {/* Content skeleton */}
          <div className="flex-1 min-w-0">
            <div className="h-4 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" style={{ width: `${50 + item * 10}px` }} />
            <div className="h-3 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" style={{ width: `${80 + item * 15}px` }} />
          </div>
        </div>
      ))}
    </>
  );
};

export default TicketsSkeleton;
